import * as Yup from 'yup';

export const ProfileApplyCandidateToPositionFormValidationSchema = Yup.object().shape(
  {
    searchType: Yup.object()
      .nullable()
      .when(['extended'], (extended, schema) =>
        extended ? schema.required('This field is required') : schema
      ),

    clients: Yup.array()
      .nullable()
      .when(['extended'], (extended, schema) =>
        extended ? schema.required('This field is required') : schema
      ),

    processIds: Yup.array()
      .nullable()
      .required('This field is required'),

    sendEmail: Yup.object()
      .nullable()
      .required('This field is required'),

    dateApply: Yup.string()
      .nullable()
      .test(
        'validate-dateApply',
        'Apply Date cannot be later than current time.',
        value => {
          if (value) {
            const applyDate = new Date(value);

            return applyDate < new Date();
          }
          return true;
        }
      )
      .required('This field is required'),
  }
);
